<template>
    <Teleport to="body">
        <div class="modal fade z:$(comment-modal-zindex)! {content:'';fixed:z:$(comment-modal-overlay-zindex);bg:#0000001A;top:0;left:0;w:full;h:full}::before" ref="root" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered adjust-margin">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title f:20!">切換留言身份</h3>
                        <button class="btn-close" data-bs-dismiss="modal" type="button"></button>
                    </div>
                    <div class="modal-body p:24!">
                        <div class="mb:16">選擇留言身份，以其他的身份在貼文互動。</div>
                        <div class="{p:8|12;flex;ai:center;gap:16}>div {font:bold}>div_.row-label">
<!-- 姓名 -->
                            <div>
                                <member-avatar :icon-url="userInfo.avatar_url" :short-name="userInfo.short_name" :type="3"></member-avatar>
                                <div class="flex ai:center gap:16 flex:1">
                                    <span class="row-label">{{ userInfo.name }}</span>
                                </div>
                                <div>
                                    <input class="form-check-input" type="radio" :value="3" v-model="type" />
                                </div>
                            </div>
<!-- 大學1 -->
                            <template v-if="userInfo.college_id">
                                <div>
                                    <img alt="" class="w:32" src="asset/image/avatar-college.svg" />
                                    <div class="flex ai:center gap:16 flex:1">
                                        <span class="row-label">{{ userInfo.college_name }}</span>
                                    </div>
                                    <div>
                                        <input class="form-check-input" type="radio" :value="1" v-model="type" />
                                    </div>
                                </div>
                            </template>
                            <div class="{flex:col;ai:start!}@<sm" v-else>
                                <div class="flex ai:center gap:16">
                                    <img alt="" class="w:32" src="asset/image/avatar-college.svg" />
                                    <span class="row-label">學校</span>
                                </div>
                                <div class="flex:1 w:full">
                                    <college-mail :closeable="false" @error="notifyError" :index="1" placeholder="驗證學校信箱" @send="sendCode" @update="collegeChanged" value=""></college-mail>
                                </div>
                            </div>
<!-- 大學2 -->
                            <template v-if="userInfo.college2_id">
                                <div>
                                    <img alt="" class="w:32" src="asset/image/avatar-college.svg" />
                                    <div class="flex ai:center gap:16 flex:1">
                                        <span class="row-label">{{ userInfo.college2_name }}</span>
                                    </div>
                                    <div>
                                        <input class="form-check-input" type="radio" :value="2" v-model="type" />
                                    </div>
                                </div>
                            </template>
<!-- 大學3 -->
                            <template v-if="userInfo.college3_id">
                                <div>
                                    <img alt="" class="w:32" src="asset/image/avatar-college.svg" />
                                    <div class="flex ai:center gap:16 flex:1">
                                        <span class="row-label">{{ userInfo.college3_name }}</span>
                                    </div>
                                    <div>
                                        <input class="form-check-input" type="radio" :value="5" v-model="type" />
                                    </div>
                                </div>
                            </template>
<!-- 暱稱 -->
                            <div class="{flex-wrap:wrap}@<sm">
                                <img alt="" class="w:32" src="asset/image/avatar-nickname.svg" />
                                <div class="flex ai:center gap:16 {order:2;flex:1}@<sm">
                                    <span class="row-label">暱稱</span>
                                </div>
                                <template v-if="!userInfo.nickname">
                                    <div class="rel {flex:1}@sm {order:4;w:full}@<sm">
                                        <input class="form-control w:full {max-w:327}@sm" :class="{ success: checked, 'error-border': error === 'error.nickname-required' }" placeholder="輸入暱稱" v-model.trim="nickname" />
                                    </div>
                                    <div class="{order:3}@<sm">
                                        <button class="inline-block b:0 p:8|12 r:8 bg:#EEF3FB color:primary {bg:#CECECE;color:#6F737D}:disabled" @click="saveNickname" :disabled="!nickname" type="button">
                                            <i class="fa-solid fa-plus"></i> 新增
                                        </button>
                                    </div>
                                </template>
                                <template v-else-if="inEdit">
                                    <div class="rel {flex:1}@sm {order:4;w:full}@<sm">
                                        <input class="form-control w:full {max-w:327}@sm" :class="{ success: checked, 'error-border': error === 'error.nickname-required' }" placeholder="輸入暱稱" v-model.trim="nickname" />
                                    </div>
                                    <div class="{order:3}@<sm">
                                        <button class="inline-block b:0 p:8|12 r:8 bg:white color:#5E6472" @click="setEditMode(false)" type="button">取消</button>
                                        <button class="inline-block b:0 p:8|12 r:8 bg:#EEF3FB color:primary {bg:#CECECE;color:#6F737D}:disabled" @click="saveNickname" :disabled="nickname === userInfo.nickname" type="button">確認</button>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="rel {flex:1}@sm {order:4;w:full}@<sm">
                                        <div class="flex ai:center">
                                            <input class="form-control w:full {max-w:327}@sm" readonly placeholder="輸入暱稱" v-model="userInfo.nickname" />
                                            <button class="inline-block w:20 h:20 bg:url('image/icon_pen.svg') ml:8" @click="setEditMode(true)" type="button"></button>
                                        </div>
                                    </div>
                                    <div class="{order:3}@<sm">
                                        <input class="form-check-input" type="radio" :value="4" v-model="type" />
                                    </div>
                                </template>
                            </div>
                            <div v-if="!userInfo.nickname || inEdit">
                                <div class="w:32 {hidden}@<sm"></div>
                                <div class="error-msg-area">
                                    <div class="error-msg" :class="{ error: error === 'error.nickname-length' }">最長10字中英字元</div>
                                    <div class="error-msg" :class="{ error: error === 'error.nickname-exists' }">不可與他人重複</div>
                                    <div class="error-msg" :class="{ error: error === 'error.irregular-nickname' }">不可包含 OPT、歐趴糖 字串</div>
                                </div>
                            </div>
<!-- 趴主 -->
                            <div v-if="part">
                                <img alt="" class="w:32" src="asset/image/avatar-group-master.svg" />
                                <div class="flex ai:center gap:16 flex:1">
                                    <span class="row-label">{{ part.title }}趴主</span>
                                </div>
                                <div>
                                    <input class="form-check-input" type="radio" :value="6" v-model="type" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="w:full flex jc:center gap:24">
                            <button class="btn btn-outline-secondary color:gray03" @click="close" type="button">取消</button>
                            <button class="btn btn-primary" @click="change" type="button">確認</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
    <alert-modal ref="invalidMailModal">
        <div class="f:20 font-weight:normal mt:24 color:gray02">
            請檢查您輸入的電子信箱是否正確，或私訊 OPT歐趴糖 LINE@ <a href="https://lin.ee/LpdcFiE" target="_blank">https://lin.ee/LpdcFiE</a> (@opt_campus)，截圖詳細說明您的狀況，謝謝!
        </div>
    </alert-modal>
</template>

<script setup>
    const { watchThrottled } = VueUse;

    const global = useGlobal();
    const userInfo = useUserInfo();

    const invalidMailModal = ref();
    const root = ref();

    const checked = ref(false);
    const error = ref();
    const inEdit = ref(false);
    const nickname = ref();
    const type = ref();
    const part = ref();

    let current;
    let modal;

    const change = () => {
        if (current || type.value === 6) {
            emit("change", type.value);
            close();
        } else {
            api("api/member/nickname/change-type", { type: type.value }).done((res) => {
                if (res.success) {
                    emit("change", type.value);
                    close();
                }
            });
        }
    };

    const close = () => {
        modal.hide();
    };

    const collegeChanged = (newData) => {
        userInfo.college_id = newData.college.id;
        userInfo.college_name = newData.college.name;

        global.success("大學信箱驗證成功");
    };

    const countdown = (obj) => {
        obj.countdown -= 1;

        if (obj.countdown) {
            setTimeout(() => countdown(obj), 1000);
        }
    };

    const emit = defineEmits(["change"]);

    const notifyError = (message) => {
        global.error(message);
    };

    const saveNickname = () => {
        error.value = "";

        api("api/member/nickname/save", { nickname: nickname.value }, { prevent: true }).done((res) => {
            if (res.success) {
                userInfo.nickname = nickname.value;
                inEdit.value = false;
                type.value = 4;
            } else {
                error.value = res.error;
            }
        });
    };

    const sendCode = (obj) => {
        obj.error = false;
        api(obj.url, { target: obj.target }, { prevent: true }).done((res) => {
            if (res.success) {
                obj.countdown = 180;
                obj.pending = true;
                obj.code = "";
                setTimeout(() => countdown(obj), 1000);
                setTimeout(() => $(obj.input).focus());
            } else {
                obj.error = true;
                notifyError(res.message);
            }
        });
    };

    const setEditMode = (flag) => {
        inEdit.value = flag;

        if (flag) {
            nickname.value = userInfo.nickname;
            checked.value = false;
            error.value = "";
        }
    }

    const show = async (currentType, currentPart) => {
        if (await userInfo.init()) {
            current = currentType;
            type.value = currentType || userInfo.type;
            part.value = userInfo.parts?.includes(currentPart?.id) ? currentPart : null;

            modal.show();
        }
    }

    defineExpose({ show });

    onMounted(() => {
        modal = new bootstrap.Modal(root.value);
    });

    watchThrottled(nickname, () => {
        checked.value = false;
        error.value = "";

        if (nickname.value) {
            api("api/member/nickname/check", { nickname: nickname.value }, { prevent: true }).done((res) => {
                if (res.success) {
                    checked.value = true;
                } else {
                    error.value = res.error;
                }
            });
        }
    }, { throttle: 500 });
</script>
